$(function() {
  $.fn.size = function() {
      return this.length;
  }
});
jQuery(function($){
  // blog masonry
  if ($('#blog .grid').length) {

    var size_li = $("#blog .grid .post").size();
    var x = 6;

    if (x >= size_li) { $('#blog .loadmore a.button').hide(); }

    var $grid = $('#blog .grid').masonry({ itemSelector: '.post' });

    $('#blog .grid .post:lt(' + x + ')').show();

    $grid.imagesLoaded().progress( function() {
      $grid.masonry('layout');
    });

    $('#blog .loadmore a.button').click(function(e) {
      e.preventDefault();
      x = (x + 6 <= size_li) ? x + 6 : size_li;
      $('#blog .grid .post:lt(' + x + ')').show();
      $grid.masonry('layout');
      if (x >= size_li) { $('#blog .loadmore a.button').hide(); }
    });

  }
});
